export enum GameState {
	Wanted = "wanted",
	Owned = "owned",
	PreviouslyOwned = "previouslyOwned",
	NotOwned = "notOwned",
	ForTrade = "forTrade",
}
